exports.baseURL = "https://rendezvous.livyvoice.com/";
// exports.baseURL = "http://192.168.1.39:5000/";
exports.key = "#TkUM],WEeDr))$FcQlz>EmU4+.f)o";
